import Piccc from "../../../assets/img/NewsImgs/tabligh4.jpg"
import Calendar from "../../../assets/icon/NewsIcons/NewsCalendarBlueSs";
import Clock from "../../../assets/icon/NewsIcons/NewsClockBlueSs";
import See from "../../../assets/icon/NewsIcons/NewsSee2"
import { Link } from "react-router-dom";
import { apiAsset } from "../../../commons/inFormTypes";
import parse from 'html-react-parser';

export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
      let new_str = str + " ";
      new_str = str?.substr(0, len);
      new_str = str?.substr(0, new_str.lastIndexOf(" "));
      new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
      return new_str + "...";
    }
    return str;
  };
  
const ImportantNews2 = (props) => {
    return(
        <div className="h-[380px] bg-white px-[15px] pt-[15px] pb-2 flex flex-col justify-between rounded-[15px] shadow-3xl md:max-h-auto d1690:h-[400px]   md:mb-[10px]  c550:h-fit">
            <div>
                <a href={props.link}>
                <div className="relative">
                    <img loading="lazy" className="w-full h-[176px] rounded-[15px]  md:h-[176px] md:object-fill" src={apiAsset+props.imgPath} alt={props?.label} />
                    <div className="w-[40px] h-[30px] flex justify-center items-center -mt-[30px]  absolute bg-white rounded-tl-[15px]"><See className="md:w-[18px]"/></div>
                    <div className=" w-5 h-5 bg-transparent -mt-[50px] shadow-4xl  absolute rounded-br-[15px]"></div>
                    <div className=" w-5 h-5 bg-transparent -mt-[20px] shadow-5xl mr-[40px] absolute rounded-br-[15px] "></div>

                </div>
                </a>
                <a href={props.link}>
                <p className="text-[17px] font-IRANYekanExtra  mt-2 md:text-[14px]">{props?.title}</p>
               
                </a>
              {/* <div className="flex w-[100%] justify-start items-center mt-2">
                        <div className="flex justify-start items-center border-l-[1px] border-lightGray pl-[6px]">
                            
                            <p className="text-mainColor2 text-[8px] font-IRANYekanMedium ">
                             {props?.date}  
                            </p>
                        </div>
                        <div className="flex justify-start items-center pr-[6px]">
                            
                            <p className="text-mainColor2 text-[8px] font-IRANYekanMedium">
                            {props?.time}
                            </p>
                        </div>
                    </div> */}
                   
                    <p className="font-IRANYekanMedium text-[16px] text-justify ml-3 mt-4 md:text-[13px] md:mt-[10px] c550:mb-2">
                        
                    {parse(truncate(props?.text,100))}

                </p>
                </div>
                <div className="flex w-[100%] justify-end items-center">
              <div className="flex justify-start items-center border-l-[1px] border-mainColor pl-[10px]">
                <Calendar color="#012272" className="ml-[6px]" />
                <p className="text-mainColor2 text-[15px] font-IRANYekanNormal md:text-[11px]">{props.date}</p>
              </div>
              <div className="flex justify-start items-center pr-[10px]">
                <Clock color="#012272" className="ml-[6px]" width="11px" height="12px" />
                <p className="text-mainColor2 text-[15px] font-IRANYekanNormal md:text-[11px]">{props.time}</p>
              </div>
            </div>
           
                
            
        </div>
    )
}

export default ImportantNews2;